import { createRouter } from 'stencil-router-v2';

export { Components, JSX } from './components';

export const Router = createRouter();

if (typeof window !== 'undefined') {
  Router.onChange('url', () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });
}
